import React, { useState, useEffect, useCallback } from "react"
import { useHistory } from "react-router-dom"

import CustomButton from "../../../v2-components/Antd/Button"
import CustomAlert from "../../../v2-components/Antd/Alert"

import AddUserForm from "../components/AddUserForm"
import { useUserService } from "../hooks/useUserService"
import { Enviroment } from "../../../_config/constants/enviroment-v2.constant"
import "../styles/common.css"
import "../styles/forms.css"

const AddUser = () => {
    const history = useHistory()
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const { createUser } = useUserService()

    const [isMounted, setIsMounted] = useState(true)

    useEffect(() => {
        return () => setIsMounted(false)
    }, [])

    const handleFinish = useCallback(async (values) => {
        setLoading(true)
        setError(null)

        const { roles, ...restValues } = values

        try {
            const response = await createUser({
                ...restValues,
                roles: Array.isArray(roles) ? roles : [roles],
                country: Enviroment['COUNTRY'],
            })

            if (!response) {
                throw new Error('El servidor no devolvió una respuesta válida.')
            }
            
            console.log('Respuesta del servidor:', response)

            if (isMounted) {
                setTimeout(() => history.push('/v2/admin-user-management'), 2000)
            }

        } catch (error) {
            console.error(error)
            if (isMounted) {
                setError(error.message || 'Hubo un problema al crear el usuario.')
            }
        } finally {
            if (isMounted) {
                setLoading(false)
            }
        }

    }, [createUser, history, isMounted])

    const handleCancel = useCallback(() => {
        history.push("/v2/admin-user-management?tab=2")
    }, [history])

    return (
        <div className="container">
            <h2 className="page-title">Nuevo usuario</h2>

            <CustomButton className="no-padding-button" type="link" onClick={handleCancel} style={{ margin: 0, padding: 0 }}>
                Volver a usuarios
            </CustomButton>

            <AddUserForm onFinish={handleFinish} onCancel={handleCancel} loading={loading} />

            {error && <CustomAlert message={error} type="error" className="form-error" />}
        </div>
    )
}

export default React.memo(AddUser)
